import classNames from 'classnames';
import styles from './Paragraph.module.scss';

export interface ParagraphProps {
	children: React.ReactNode;
	className?: string;
}

export const UI_Paragraph = ({ children, className }: ParagraphProps) => <p className={classNames(styles.Paragraph, className)}>{children}</p>;
